import * as React from "react";
import { Trans } from "react-i18next";
import { ExperienceTransactionRealMoneyPurchaseDetailsFragmentFragment } from "../../../hooks/useXPTransactions/graphql/XPTransactionsFragment.generated";

export const ExperienceTransactionRealMoneyPurchaseDetails = ({
  details,
  earnedXP,
  totalXP,
}: {
  details: ExperienceTransactionRealMoneyPurchaseDetailsFragmentFragment;
  earnedXP: number;
  totalXP: number;
}) => {
  return (
    <Trans
      i18nKey="xp_transaction.ExperienceTransactionRealMoneyPurchaseDetails"
      components={{
        xp: <span className="font-bold" />,
        total: <span className="font-bold" />,
      }}
      values={{ xp: earnedXP, total: totalXP }}
    />
  );
};
